var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"tile":"","flat":"","color":"white","app":""}},[_c('div',{staticClass:"head-contents-box",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"head-contents"},[_c('img',{staticClass:"head-logoimg",attrs:{"src":"https://qlipper.jp/img/logo.svg","alt":"Qlipper"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }